import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button, useTheme } from "@mui/material";

export const AddNewButton = ({
  text,
  onButtonClick,
  filled = true,
  showIcon = true,
}) => {
  const theme = useTheme();

  return (
    <Button
      startIcon={showIcon && filled ? <AddCircleOutlineIcon /> : null}
      variant={filled ? "contained" : "outlined"}
      size="large"
      onClick={onButtonClick}
      sx={{
        "&&": {
          backgroundColor: filled ? theme.palette.common.black : "white",
          color: filled
            ? theme.palette.secondary.contrastText
            : theme.palette.common.black,
          borderColor: filled ? "transparent" : theme.palette.common.black,
          borderWidth: filled ? 0 : 2,
          fontSize: "12px",
          fontWeight: "500",
          width: "100%",
          padding: "12px",
          textTransform: "none",

          "&:hover": {
            backgroundColor: filled
              ? theme.palette.grey[700]
              : theme.palette.grey[200],
          },

          "@media (min-width: 1024px)": {
            fontSize: "18px",
            padding: "15px 25px",
            width: "auto",
          },
        },
      }}
    >
      {text}
    </Button>
  );
};
